import { FC, useEffect, useRef, useState } from "react";

import { useSetAtom } from "jotai";

import { SimpleGrid, createStyles } from "@mantine/core";
import { ref, getDatabase, get } from "firebase/database";

import { FormCard } from "./components/FormCard";
import { Header } from "@components/Header/Header";
import { Content } from "@components/Content/Content";
import { PageLoader } from "@components/PageLoader/PageLoader";

import { emailAtom } from "./atoms/email.atom";

const useStyles = createStyles((t) => ({
  grid: {
    width: "100%",
    [`@media (min-width: ${t.breakpoints.md}px)`]: {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
  },
}));

export const PortalRoute: FC = () => {
  const { classes } = useStyles();
  const setEmail = useSetAtom(emailAtom);
  const [isLoading, setIsLoading] = useState(true);

  const $toRefs = { setEmail };
  const toRefs = useRef($toRefs);
  useEffect(() => {
    toRefs.current = $toRefs;
  });

  useEffect(() => {
    setIsLoading(true);
    const db = getDatabase();
    get(ref(db, "/"))
      .then((res) => {
        toRefs.current.setEmail(res.val().email);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) return <PageLoader />;

  return (
    <>
      <Header />
      <Content>
        <SimpleGrid className={classes.grid}>
          <FormCard form="EventRegistration" />
        </SimpleGrid>
      </Content>
    </>
  );
};
